import { useTranslation } from 'react-i18next';
import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllRecruitments() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderList
      title={`All ${t('modules.recruitment').toLowerCase()}`}
      newPath="/panel/recruitments/new"
      newLabel={`New ${t('modules.recruitment').toLowerCase()}`}
    />
  );
}
